module.exports = __webpack_public_path__ + "static/media/icone-claropay.45f28369.svg";